import { I18n } from 'aws-amplify';
import { useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
    multiPanelAtom,
    knowledgeViewSelectedAtom,
    listenOnChangeKnowledgeViewSelectedAtom,
    isUsingChatAIAtom
} from '@/state/atom/panelAtom';
import Constant from '@/common/constant/Constant';
import {
    drilldownDataSelectedForLog,
    publicKnowledgeHitNumberTicketAtom
} from '@/state/atom/ticketAtom';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom, viewKnowledgeProjectSelectedAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { Tooltip, MenuItem, Menu, Button } from '@material-ui/core';
import {
    handleToggleUsingKnowledgeTicketList,
    handleUpdateSearchCondition
} from '../handler/ChatAIHandler';
import MCPServerDropdown from './MCPServerDropdown';
import Utils from '@/common/utils/utils';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import { destinationPrjIdAtom } from '@/state/atom/ticketKnowledgeAtom';
import { PropTypes } from 'prop-types';
import { checkModelUnsupport } from '@/component/system/handler/OrganizationProfileHandler';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { cloneDeep } from 'lodash';

GroupButtonKnowledge.propTypes = {
    API: PropTypes.any,
    projectInfo: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    enqueueSnackbar: PropTypes.any,
    reOpenKnowledgePanel: PropTypes.any,
    projectIdKnowledgeSelected: PropTypes.any,
    isInvalidPrecondition: PropTypes.any,
    tabNameChatAI: PropTypes.any,
    corporationSelected: PropTypes.any,
    initHitNumber: PropTypes.any,
    isUsingKnowledgeService: PropTypes.any,
    toggleUsingKnowledgeTicketList: PropTypes.any,
    setToggleUsingKnowledgeTicketList: PropTypes.any,
    usingChatGptModel: PropTypes.any,
    setUsingChatGptModel: PropTypes.any,
    mcpServerOptions: PropTypes.array,
    selectedMcpServers: PropTypes.array,
    setSelectedMcpServers: PropTypes.func
};


export default function GroupButtonKnowledge({
    API,
    projectInfo,
    panelId,
    tabId,
    enqueueSnackbar,
    reOpenKnowledgePanel,
    projectIdKnowledgeSelected,
    isInvalidPrecondition,
    tabNameChatAI,
    corporationSelected,
    initHitNumber,
    isUsingKnowledgeService,
    toggleUsingKnowledgeTicketList,
    setToggleUsingKnowledgeTicketList,
    usingChatGptModel,
    setUsingChatGptModel,
    mcpServerOptions,
    selectedMcpServers,
    setSelectedMcpServers,
    isEnableMcpInVersion,
    usingReasoningEffort,
    setUsingReasoningEffort,
    selectedCorporationDetail,
    chatGPTModelListOptions
}) {
    const reasoningEfforts = OpenAiUtil.getReasoningEffortOptionsForModel(usingChatGptModel);
    const [anchorEl, setAnchorEl] = useState(null);
    const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
    const [hoveredModel, setHoveredModel] = useState(null);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const isOpeningKnowledgeListPanel = panelList.some(p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);
    const [viewSelectedKnowledge, setViewSelectedKnowledge] = useRecoilState(knowledgeViewSelectedAtom);
    const listenOnChangeViewSelectedKnowledge = useRecoilValue(listenOnChangeKnowledgeViewSelectedAtom);
    const drilldownDataForLog = useRecoilValue(drilldownDataSelectedForLog);
    const totalTickets = useRecoilValue(publicKnowledgeHitNumberTicketAtom);
    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(corporationAtom);
    const [isUsingChatAI, setIsUsingChatAI] = useRecoilState(isUsingChatAIAtom);
    const viewKnowledgeProjectSelected = useRecoilValue(viewKnowledgeProjectSelectedAtom);
    const destinationPrjId = useRecoilValue(destinationPrjIdAtom);
    let chatGPTModelListOfCorp = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting)?.listChatGptModel;
    
    useEffect(() => {
        // re-check isUsingChatAI
        if (!isOpeningKnowledgeListPanel) {
            (
                async () => await Utils.isUsingFunctionService(
                    viewKnowledgeProjectSelected,
                    corporationDetail,
                    'usingChatAI',
                    setIsUsingChatAI
                )
            ) ()
        }

    }, [isOpeningKnowledgeListPanel]);

    const getTitleProject = () => {
        const titleProjectValue = projectIdKnowledgeSelected === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
        ? I18n.get('CM-LABEL-ALL-KNOWLEDGE-IN-ORG')
        : projectInfo?.projectName

        return (
            <Tooltip
                title={titleProjectValue}
                placement="top"
                arrow={true}
                disableHoverListener={
                    !toggleUsingKnowledgeTicketList
                    || isInvalidPrecondition
                    || !projectIdKnowledgeSelected
                }
            >
                <p
                    className={`content-msg overFlow-lineHeight`}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100px',
                    }}
                >
                    {titleProjectValue}
                </p>
            </Tooltip>
        );
    };


    /**
     * Check conditions to show MCP Server dropdown.
     * Log all check steps and the returned result for debug.
     */
    const isShowMCPServerDropdown = () => {
        const currentCorporationContractType =
            corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM;

        //selected corporation setting MCP Server
        const selectedCorporationSetting = Utils.convertJSONDataToObject(
            selectedCorporationDetail?.corporationSetting
        );
        const selectedCorporationLimitValue = selectedCorporationDetail?.limitValue;
        const isRootOnMCPServerOfSelectedCorporation =
            selectedCorporationLimitValue?.mcpServer === Constant.STATUS_SERVICE_PERMISSION.ON;
        const usingMCPServerOfSelectedCorporation =
            selectedCorporationSetting?.usingMCPServer === Constant.STATUS_SERVICE_PERMISSION.ON;

        //current corporation setting MCP Server
        const currentCorporationSetting = Utils.convertJSONDataToObject(
            corporationDetail?.corporationSetting
        );
        const currentCorporationLimitValue = corporationDetail?.limitValue;
        const isRootOnMCPServerOfCurrentCorporation =
            currentCorporationLimitValue?.mcpServer === Constant.STATUS_SERVICE_PERMISSION.ON;
        const usingMCPServerOfCurrentCorporation =
            currentCorporationSetting?.usingMCPServer === Constant.STATUS_SERVICE_PERMISSION.ON;

        const hasMcpServerOptions = mcpServerOptions.length > 0;

        let result = true;
        if (!currentCorporationContractType || !hasMcpServerOptions) {
            result = false;
        } else if (
            (!isRootOnMCPServerOfSelectedCorporation || !usingMCPServerOfSelectedCorporation) &&
            (!isRootOnMCPServerOfCurrentCorporation || !usingMCPServerOfCurrentCorporation)
        ) {
            result = false;
        }

        return result;
    };

    const handleCloseMcpServerMenu = () => {
        // comment for now
        // let currentPanelList = cloneDeep(panelList);
        // if (Utils.isEmptyArray(currentPanelList)) return;
        // let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
        // if (currentPanelIndex === -1) return;
    
        // let currentPanel = currentPanelList[currentPanelIndex];
    
        // if (Utils.isEmptyArray(currentPanel.tabList)) return;
        // let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
        // if (currentTabIndex === -1) return;
    
        // // Save current MCP servers selection
        // currentPanelList[currentPanelIndex].tabList[
        //     currentTabIndex
        // ].component.props.filterKnowledgeListData.listSelectedMcp = cloneDeep(selectedMcpServers);
    
        // setPanelList([...currentPanelList]);
    };
        
    const handleN8nServerSelectionChange = (selectedIds) => {
        setSelectedMcpServers(selectedIds);
    };

    const handleN8nServerApply = (selectedIds) => {
        // do nothing
    };

    const handleOpenMenu = event => {
        setAnchorEl(event.currentTarget);
        setSubmenuAnchorEl(null);

    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setHoveredModel(null);
        setSubmenuAnchorEl(null);
    };

    const handleSelectHover = (event, model) => {
        console.log('handleSelectHover', {event, model})
        setHoveredModel(model.id);
        if (OpenAiUtil.isSupportReasoning(model.id)) {
            // const modelSpecificOptions = OpenAiUtil.getReasoningEffortOptionsForModel(model.id);
            setSubmenuAnchorEl(event.currentTarget);
            setUsingReasoningEffort(preState => {
                // Keep current value if it's valid for the new model, otherwise use model default.
                // if (preState && modelSpecificOptions.includes(preState)) {
                //     return preState;
                // }
                return OpenAiUtil.defaultReasoningEffort(model.id);
            });
            setUsingChatGptModel(model?.id);
        } else {
            setSubmenuAnchorEl(null);
        }
    };

    const handleSelectModel = modelId => {
        setUsingChatGptModel(modelId);
        handleCloseMenu();
        if (OpenAiUtil.isSupportReasoning(modelId)) {
            return setUsingReasoningEffort(OpenAiUtil.defaultReasoningEffort(modelId));
        }
        setUsingReasoningEffort(null);
    };

    const handleSelectSubmenu = (modelId, level) => {
        setUsingChatGptModel(modelId);
        setUsingReasoningEffort(level);
        handleCloseMenu();
    };

    const getGptModelAndReasoingEffort = () => {
        return usingReasoningEffort && OpenAiUtil.isSupportReasoning(usingChatGptModel) 
            ? `${usingChatGptModel} ${usingReasoningEffort}`
            : usingChatGptModel;
    };

    const getModelItemClassName = modelId =>
        `font-style-gpt-model-menu ${
            checkModelUnsupport(modelId, chatGPTModelListOfCorp)
                ? 'd-hidden'
                : `model-ai-item${modelId === usingChatGptModel ? ' selected' : ''}`
        }`;

    return (
        <div className="group-button-chat-ai-container">
            <div className="left">
                <div className="d-flex align-items-center justify-content-center gap-8">
                    <Tooltip
                        title="参照ナレッジ一覧"
                        placement="bottom"
                        arrow={true}
                        disableHoverListener={
                            !toggleUsingKnowledgeTicketList
                            || isInvalidPrecondition
                            || !projectIdKnowledgeSelected
                            || !isUsingKnowledgeService
                        }
                    >
                        <img
                            src={`/assets/image/icon-knowledge-chat-ai-${
                                (!toggleUsingKnowledgeTicketList || isInvalidPrecondition || !isUsingKnowledgeService  || !projectIdKnowledgeSelected)
                                    ? 'disable'
                                    : 'enable'
                            }.svg`}
                            alt="icon"
                            onClick={reOpenKnowledgePanel}
                            className={`icon-knowledge-chat-ai ${
                                !toggleUsingKnowledgeTicketList || isInvalidPrecondition || !isUsingKnowledgeService  || !projectIdKnowledgeSelected
                                    ? 'disabled-event'
                                    : ''
                            }`}
                        />
                    </Tooltip>
                    {(!isInvalidPrecondition && toggleUsingKnowledgeTicketList && isUsingKnowledgeService && projectIdKnowledgeSelected) && (
                        getTitleProject()
                    )}
                    
                    <div className="chat-gpt-model-select">
                        <Button
                            className='font-style-gpt-model-menu'
                            variant="outlined"
                            onClick={handleOpenMenu}
                            data-cy="header-top-select-gpt-model"
                            style={{
                                textTransform: 'none',
                                textOverflow: 'ellipsis',
                                maxWidth: '12rem',
                                minWidth:"7.5rem",
                                whiteSpace: 'nowrap',
                                display:"flex",
                                justifyContent:"space-between",
                                alignItems:"center"
                            }}
                            endIcon={ <ExpandMoreIcon />}
                        >
                            {getGptModelAndReasoingEffort()}
                        </Button>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left'
                            }}
                            PaperProps={{
                                style: {
                                    marginTop: '3rem',
                                    width: "9rem"
                                }
                            }}
                        >
                            {chatGPTModelListOptions.map(item =>
                               OpenAiUtil.isSupportReasoning(item.id)  ? (
                                    <MenuItem
                                        className={getModelItemClassName(item.id)}
                                        key={item.id}
                                        onClick={e => handleSelectHover(e, item)}
                                        aria-haspopup="true"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                        sx={{
                                            '&:hover':{
                                                  backgroundColor: '#F4F2F2',
                                            }
                                        }}
                                    >
                                        {item.name} <KeyboardArrowRight/>
                                    </MenuItem>
                                ) : (
                                    <MenuItem
                                        key={item.id}
                                        onClick={() => handleSelectModel(item.name)}
                                        className={getModelItemClassName(item.id)}
                                            sx={{
                                            '&:hover':{
                                                  backgroundColor: '#F4F2F2',
                                            }
                                        }}
                                    >
                                        {item.name}
                                    </MenuItem>
                                )
                            )}
                        </Menu>
                        {/* Submenu */}
                        <Menu
                            anchorEl={submenuAnchorEl}
                            open={
                                OpenAiUtil.isSupportReasoning(hoveredModel) &&
                                Boolean(submenuAnchorEl)
                            }
                            onClose={() => setHoveredModel(null)}
                            style={{ pointerEvents: 'none' }} // Prevent MUI from capturing pointer events here
                            MenuListProps={{
                                onMouseEnter: () =>
                                    setHoveredModel(hoveredModel),
                                style: { pointerEvents: 'auto' } // Enable pointer events for the list itself
                            }}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left'
                            }}
                            PaperProps={{
                                style: {
                                    marginLeft: '0.1rem'
                                }
                            }}
                        >
                            {reasoningEfforts.map(level => (
                                <MenuItem
                                    key={level}
                                    onClick={() => handleSelectSubmenu(usingChatGptModel, level)}
                                    className={
                                        `font-style-gpt-model-menu model-ai-item` +
                                        (level === usingReasoningEffort ? ' selected' : '')
                                    }
                                    selected={level === usingReasoningEffort}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#F4F2F2'
                                        }
                                    }}
                                >
                                    {level}
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                    {/* MCP Server Multi-Select Dropdown */}

                    { isShowMCPServerDropdown() && (
                        <MCPServerDropdown
                            serverList={mcpServerOptions}
                            selectedServers={selectedMcpServers}
                            onSelectionChange={handleN8nServerSelectionChange}
                            onApply={handleN8nServerApply}
                            corporationDetail={corporationDetail}
                            isEnableMcpInVersion={isEnableMcpInVersion}
                            handleCloseMcpServerMenu={handleCloseMcpServerMenu}
                        />
                    )}
                </div>
            </div>

            <div className="group-btn-submit-reset">

                {/* Toggle usingKnowledgeTicketList  */}
                <div className={`reference-SolutionDesk-Of-Knowledge-Ticket ${!isUsingKnowledgeService && 'hidden'}`}>
                    <p className='reference-knowledge-title'>SolutionDesk内のナレッジを参照</p>
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id={`switch-referenceSolutionDeskOfKnowledgeTicket-mode`}
                            checked={toggleUsingKnowledgeTicketList}
                            value={toggleUsingKnowledgeTicketList}
                            onChange={() => handleToggleUsingKnowledgeTicketList(
                                API,
                                panelId,
                                tabId,
                                panelList,
                                setPanelList,

                                viewSelectedKnowledge,
                                drilldownDataForLog,
                                totalTickets,

                                userDetail,
                                projectInuseDetail,
                                corporationDetail,

                                tabNameChatAI,
                                corporationSelected,
                                projectIdKnowledgeSelected,
                                toggleUsingKnowledgeTicketList,
                                setToggleUsingKnowledgeTicketList,
                                initHitNumber,
                                selectedMcpServers
                            )}
                        />
                        <label htmlFor={`switch-referenceSolutionDeskOfKnowledgeTicket-mode`}></label>
                    </div>
                </div>

                {/* btn reload ViewSelectedKnowledge */}
                <Tooltip
                    title={I18n.get('LABEL-TOOLTIP-BUTTON-SAVE-SEARCH-CONDITION')}
                    arrow={true}
                    disableHoverListener={
                        !isOpeningKnowledgeListPanel
                        || Utils.isEmptyObject(viewSelectedKnowledge)
                        || !isUsingKnowledgeService
                    }
                >
                    <div className={
                            `d-flex align-items-center justify-content-center gap-8 ${
                                (!toggleUsingKnowledgeTicketList || !isUsingKnowledgeService) && 'hidden'
                            }`
                        }
                    >
                        <img
                            src={`/assets/image/icon-reload.svg`}
                            alt="icon"
                            onClick={() => handleUpdateSearchCondition(
                                setViewSelectedKnowledge,
                                listenOnChangeViewSelectedKnowledge,
                                
                                panelList, 
                                setPanelList, 
                                panelId, 
                                tabId,
                                enqueueSnackbar,
                                viewKnowledgeProjectSelected,
                                API,
                                viewSelectedKnowledge,
                                drilldownDataForLog,
                                totalTickets,
                                userDetail,
                                projectInuseDetail,
                                corporationDetail,
                                tabNameChatAI,
                                corporationSelected,
                                projectIdKnowledgeSelected,
                                isUsingChatAI,
                                destinationPrjId
                            )}
                            className={`icon-reload ${
                                !isOpeningKnowledgeListPanel || Utils.isEmptyObject(viewSelectedKnowledge)
                                    ? 'disabled-event'
                                    : ''
                            }`}
                        />
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}

